import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PersonAddIcon from '@mui/icons-material/PersonAddRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import { UserLoginContext } from '../../../../contexts/LoggedInUserContext';
import { sendEvents } from '../../../../redux/actions/Home';
// import { containRewards } from '../../../../services/helperFunctions';

export const BottomNavigationBar = () => {
  const { userData } = useContext(UserLoginContext);
  const location = useLocation();
  const [value, setValue] = React.useState(window.location.pathname);
  // const rewardCondition = localStorage.getItem('rewardsData') !== 'undefined' && JSON.parse(localStorage.getItem('rewardsData')) ? containRewards(JSON.parse(localStorage.getItem('rewardsData'))) : true;
 
  // remove starting index from string
  const removeStartingIndex = (str) => {
    if (str == '/') {
      return 'homepage';
    }
    if (str.charAt(0) === '/') {
      return str.substr(1);
    }
    return str;
  };

  const logo = (fill) => (
    <svg width="25" height="25" viewBox="0 0 20 20" style={{ color: 'red' }} fill={value == '/healthfirst' ? '#204B6B' : '#626262'} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.89939 0H14.1005L14.1005 14.1001H14.1001V14.1005L0 14.1005V5.89939L5.89939 5.89938L5.89939 0Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.1006 20H5.89955L5.89955 5.89992H5.89992V5.89888L20 5.89888V14.0999L14.1006 14.0999L14.1006 20Z" />
      <path d="M11.5921 12.2038C11.5828 12.1626 11.5668 12.1193 11.5554 12.0851C12.6363 9.68931 16.1411 10.6616 16.829 8.47789C16.3581 9.97275 13.365 8.34086 11.1638 8.94984C11.2098 8.59225 11.3025 8.22736 11.435 7.83004C12.4918 4.47523 16.0931 4.24695 16.8309 1.90479C16.0909 4.25384 10.6356 2.97696 8.75464 6.73555C8.31774 6.02761 7.78848 5.47163 7.02989 5.22001C5.79465 4.8103 4.76196 5.85251 4.76196 5.85251C4.76196 5.85251 5.97794 5.85259 5.9327 7.2908C5.88997 8.5092 5.23245 13.6094 17.1429 16.1905C17.1429 16.1905 13.7051 14.723 11.5921 12.2038Z" fill="url(#paint0_linear_2037_5439)" />
      <defs>
        <linearGradient id="paint0_linear_2037_5439" x1="2.8572" y1="4.76193" x2="19.0477" y2="17.6191" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#C1C1C1" />
        </linearGradient>
      </defs>
    </svg>

  );
 
  return (
    <div className="bottom-navigation-bar web-hide">
      <Box>
        <Paper
          sx={{
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10,
          }}
          elevation={3}>
          <BottomNavigation
            showLabels
            value={value}
            onChange={(e, newvalue) => { sendEvents('Click on icons', '', 'result', removeStartingIndex(newvalue), value); }}>
            <BottomNavigationAction label="Home" icon={<HomeRoundedIcon />} value="/" component={Link} to="/" />
            {
              userData && userData.subscribed && userData.subscribed.currency == 'inr' && <BottomNavigationAction label="Refer&Earn" icon={<PersonAddIcon />} value="/referral" component={Link} to="/referral" />
            }
            <BottomNavigationAction label="My SIP" icon={<FavoriteRoundedIcon />} value="/mysip" component={Link} to="/mysip" />
            { userData?.latest_subscription?.currency == 'inr' ? (<></>
              // <BottomNavigationAction
              // label="HealthFirst"
              // icon={logo()}
              // value="/healthfirst"
              // component={Link}
              // to="/healthfirst" />
            )
              : <BottomNavigationAction label="Updates" icon={<NotificationsRoundedIcon />} value="/updates" component={Link} to="/updates" />}
            <BottomNavigationAction label="Activity" icon={<BoltRoundedIcon />} value="/activity" component={Link} to="/activity" />
          </BottomNavigation>
        </Paper>
      </Box>
    </div>
  );
};

export default BottomNavigationBar;
